import { PaymentGateway } from "@fitness-app/data-models/entities/ProductsSettings";

export const paymentGatewayOptions = [
  {
    value: PaymentGateway.Stripe,
    label: "common:integration.stripe",
  },
  {
    value: PaymentGateway.Tpay,
    label: "common:integration.tpay",
  },
];
